function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import thunkHelper from 'invision-core/src/api/thunk.helper';
import { SUBSCRIBER_ID_HEADER } from 'invision-core/src/api/constants';
import { CurrentCustomerIdSelector } from '../selectors/customer.selectors';
export var RETRIEVE_SERVICE_SUSPENSION_QUOTE = {
  BEGIN: 'RETRIEVE_SERVICE_SUSPENSION_QUOTE_BEGIN',
  SUCCESS: 'RETRIEVE_SERVICE_SUSPENSION_QUOTE_SUCCESS',
  FAILURE: 'RETRIEVE_SERVICE_SUSPENSION_QUOTE_FAILURE'
};
export var retrieveServiceSuspensionQuote = function retrieveServiceSuspensionQuote(reasonCode, serviceIdentifiers) {
  return function (dispatch, getState) {
    return thunkHelper(dispatch, Object.values(RETRIEVE_SERVICE_SUSPENSION_QUOTE), {
      method: 'post',
      url: 'SubscriberManagement/CalculateServiceSuspensionQuote',
      headers: _defineProperty({}, SUBSCRIBER_ID_HEADER, CurrentCustomerIdSelector(getState())),
      data: {
        ServiceSuspensionReasonCode: reasonCode,
        ServiceIdentifiers: serviceIdentifiers
      }
    });
  };
};
export var CLEAR_SERVICE_SUSPEND_RESUME_MODAL = 'CLEAR_SERVICE_SUSPEND_RESUME_MODAL';
export var clearServiceSuspendResumeModal = function clearServiceSuspendResumeModal() {
  return {
    type: CLEAR_SERVICE_SUSPEND_RESUME_MODAL
  };
};
export var SET_SELECTED_SERVICE_IDENTIFIER_VALUES = 'SET_SELECTED_SERVICE_IDENTIFIER_VALUES';
export var setSelectedServiceIdentifierValues = function setSelectedServiceIdentifierValues() {
  var serviceIdentifierValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    type: SET_SELECTED_SERVICE_IDENTIFIER_VALUES,
    payload: serviceIdentifierValues
  };
};